import React, { useState, useContext, useEffect } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logoText from "../../../images/logo/onboardingLogo.svg";
// import { ThemeContext } from "../../../context/ThemeContext";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);

   
  // const { navigationHader, openMenuToggle, background } = useContext(
  //    ThemeContext
  // );

  const [showTitle, setShowTitle] = useState(true);

  useEffect(() => {
    let timer;
    if (!toggle) {
      timer = setTimeout(() => {
        setShowTitle(true);
      }, 400);
    } else {
      setShowTitle(false);
    }

    // Cleanup timer on unmount or if toggle changes
    return () => clearTimeout(timer);
  }, [toggle]);

  return (
    <div className="nav-header nav-h  bg-custom">
      <div>
        <Link to="/" className="brand-logo">
          {/* <img className="logo-abbr" src={logo} alt="" /> */}
          {/* <img className="logo-compact" src={logoText} alt="" /> */}

          {toggle ? (
            <div className="mt-4 ">
              <img
                src="image.png"
                alt="Logo"
                className="img-fluid  logo-img"
                style={{ width: "160px", height: "70px" }}
              />
            </div>
          ) : (
            showTitle && (
              <div className=" ">
                <img
                  src="image.png"
                  alt="Logo"
                  className="img-fluid  logo-img"
                  style={{ width: "200px", height: "100px" }}
                />
              </div>
            )
          )}
        </Link>
      </div>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          //openMenuToggle();
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}   `}>
          <span className="line red-toggle "></span>
          <span className="line red-toggle"></span>
          <span className="line red-toggle"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
